document.addEventListener('DOMContentLoaded', function () {
  const kb_tabs = document.querySelector('.kb-tabs');

  if (!kb_tabs) return;

  const buttonsContainer = kb_tabs.querySelector('.kb-tab-buttons');
  const tabs = kb_tabs.querySelectorAll('.tab-item');

  // Set initial height
  kb_tabs.style.setProperty('--tab-content-height', `${tabs[0]?.clientHeight || 0}px`);

  buttonsContainer.addEventListener('mouseover', function (event) {
    const button = event.target.closest('.kb-tab-button');
    if (!button) return;

    const index = parseInt(button.getAttribute('data-index'), 10);
    const activeButton = buttonsContainer.querySelector('.kb-tab-button.active');
    const activeTab = kb_tabs.querySelector('.tab-item.active');

    if (activeButton) activeButton.classList.remove('active');
    if (activeTab) activeTab.classList.remove('active');

    button.classList.add('active');
    if (tabs[index]) {
      tabs[index].classList.add('active');
      kb_tabs.style.setProperty('--tab-content-height', `${tabs[index].clientHeight}px`);
    }
  });
});
